<template>
	<TransitionGroup tag="div" name="toast" class="toast-host" aria-live="polite">
		<ToastItem v-for="toast in store.toasts" :key="toast.id" :toast="toast" @dismiss="store.dismiss" />
	</TransitionGroup>
</template>

<script setup lang="ts">
import ToastItem from "@/components/notifications/ToastItem.vue"
import { useToastStore } from "@/stores/toastStore"

const store = useToastStore()
</script>

<style scoped>
.toast-host {
	position: fixed;
	top: var(--spacing-md);
	right: calc(var(--spacing-lg) - 8px);
	z-index: 1300;
	display: flex;
	flex-direction: column;
	gap: var(--spacing-sm);
	pointer-events: none;
}

.toast-host > :deep(*) {
	pointer-events: auto;
}

.toast-enter-active,
.toast-leave-active {
	transition: all 0.3s ease-out;
}

.toast-enter-from,
.toast-leave-to {
	transform: translateX(100%);
	opacity: 0;
}

.toast-leave-active {
	position: absolute;
}

.toast-move {
	transition: transform 0.3s ease-out;
}
</style>
